import config from "config/config.js";
import getFreshToken from "api/xsrfToken.js";
import { updateRedux } from "componentCustom/Alert.js";

const deleteCheckIn = id => {
  // const endpoint = `${config.baseUrl}/api/tb/restaurants/update`;
  // const endpoint = "https://www.foodiestrip.com/api/tb/restaurants/update";
  const xsrfToken = getFreshToken();
  const endpoint = `${config.baseUrl}/api/checkIn/delete/${id}`;
  const options = {
    method: "DELETE",
    mode: "cors",
    headers: {
      "Access-Control-Allow-Origin": `${config.baseUrl}`,
      "Access-Control-Allow-Credentials": true,
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-XSRF-TOKEN": xsrfToken
    },
    credentials: "include"
    // body: JSON.stringify(BODY)
  };
  return fetch(endpoint, options)
    .then(response => {
      if (response.status !== 200 && response.status !== 401) {
        if (response.status) {
          updateRedux({
            title: "non autorizzato",
            danger: true,
            showCancel: false
          });
        }
        return { error: { status: response.status } };
      }
      return response.json();
    })
    .then(response => {
      // eslint-disable-next-line no-console
      if (
        response.error &&
        response.error.status &&
        response.error.status === 401
      ) {
        window.location.href = config.login;
      }
      return response;
    })
    .catch(e => {
      // eslint-disable-next-line no-console
      console.log("errore", e);
    });
};

export default deleteCheckIn;
